import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChildrenFormComponent } from './children-form/children-form.component';
import { MaterialModule } from '../material/material.module';
import { ChilrenListComponent } from './chilren-list/chilren-list.component';
import { SharedModule } from '../shared/shared.module';
import { ChildrenViewComponent } from './children-view/children-view.component';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [ChildrenFormComponent, ChilrenListComponent, ChildrenViewComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ComponentsModule],
})
export class ChildrenModule {}
